import React from 'react';
import ReactDOM from 'react-dom';
import './style/index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

if(window.location.hostname==='localhost'){
  console.log("registerServiceWorker() ");
  registerServiceWorker();
}



// WEBPACK FOOTER //
// ./src/index.js